import React from 'react';
import { useLocation } from 'react-router-dom';
import PageTitle from './PageTitle';
import AppSwitch from '../pages/AppSwitch';

// Routes that should show the AppSwitch dropdown
const routesWithAppSwitch = [
  '/apps/observation',
  '/apps/eptw',
  '/apps/document',
  '/apps/risk',
  '/apps/incident',
  '/apps/knowledge',
  '/apps/asset',
  '/apps/catches',
  '/apps/checklist',
  '/apps/training-program-tracker',
  '/apps/good-catch-v2'
];

function PageHeader() {
  const location = useLocation();
  const currentPath = location.pathname;
  
  // Check if current route should show AppSwitch
  const shouldShowAppSwitch = routesWithAppSwitch.includes(currentPath);
  
  // Get the app value for AppSwitch based on current route
  const getAppValue = () => {
    if (currentPath.includes('/good-catch-v2')) return { label: 'Good Catch V2', value: 'good-catch-v2' };
    if (currentPath.includes('/observation')) return { label: 'Observation', value: 'observation' };
    if (currentPath.includes('/eptw')) return { label: 'ePermit Work', value: 'eptw' };
    if (currentPath.includes('/document')) return { label: 'Document', value: 'document' };
    if (currentPath.includes('/risk')) return { label: 'integrated Risk Management', value: 'risk' };
    if (currentPath.includes('/incident')) return { label: 'Incident', value: 'incident' };
    if (currentPath.includes('/knowledge')) return { label: 'Knowledge', value: 'knowledge' };
    if (currentPath.includes('/asset')) return { label: 'Asset', value: 'asset' };
    if (currentPath.includes('/catches')) return { label: 'Good Catch', value: 'catches' };
    if (currentPath.includes('/checklist')) return { label: 'Checklist', value: 'checklist' };
    if (currentPath.includes('/training-program-tracker')) return { label: 'Training Program Tracker', value: 'training-program-tracker' };
    return { label: 'Observation', value: 'observation' };
  };


  return (
    <PageTitle>
      {shouldShowAppSwitch && <AppSwitch value={getAppValue()} />}
    </PageTitle>
  );
}

export default PageHeader;
